/**
 * Component to collect names of sender and receiver of a giftdonation
 */
import {Component, Input} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Donation} from "../donation/donation";
import {OptionService} from "../option/option.service";

@Component({
    selector: 'gift-donationdata',
    templateUrl: './gift.donationdata.html',
    providers: []
})
export class GiftDonationdataComponent {
    /**
     * current form for validation
     *
     * @type {FormGroup}
     */
    @Input() form: FormGroup = null;

    /**
     * current donation
     *
     * @type {Donation}
     */
    @Input() donation: Donation = null;

    /**
     * Holds the gift donation mode of the current widget
     *
     * @type {String}
     */
    giftDonationMode: string = null;

    /**
     * Icon for the button text
     */
    icon: string = null;

    /**
     * constructor of the element
     * @param optionService
     */
    constructor(private optionService: OptionService) {}

    /**
     * Initialize the component
     */
    public ngOnInit(): any {
        // get the modus of the gift donation
        this.giftDonationMode = this.optionService.getOption('gift_donation');

        if(this.giftDonationMode == 'mandatory' || this.giftDonationMode == 'optional') {
            // add the form elements
            this.form.addControl('gift.isGiftDonation', new FormControl(''));
            this.form.addControl('gift.sender', new FormControl('', [Validators.required]));
            this.form.addControl('gift.receiver', new FormControl('', [Validators.required]));

            if(this.giftDonationMode == 'mandatory') {
                // if the gift is mandatory, activate the gift donation always
                this.donation.giftData.isGiftDonation = true;
            }
            else if(this.giftDonationMode == 'optional' && this.donation.giftData.isGiftDonation === false) {
                // initially diasable name and message because they are not visible on init
                (<FormControl>this.form.controls['gift.sender']).disable({onlySelf: true});
                (<FormControl>this.form.controls['gift.receiver']).disable({onlySelf: true});
            }

            // get the icon
            this.icon = this.optionService.getOption('gift_donation_icon') || 'gift';
        }
    }

    /**
     * Toggle the ShowGiftdonationData checkbox and (de)activate validators
     */
    toggleShowGiftdonationData(): void {
        // only validate name and message if the checkobox is activated (remark: we have the old value of the checkbox here)
        if(this.donation.giftData.isGiftDonation === true) {
            (<FormControl>this.form.controls['gift.sender']).enable({onlySelf: true});
            (<FormControl>this.form.controls['gift.receiver']).enable({onlySelf: true});
        }
        else {
            (<FormControl>this.form.controls['gift.sender']).disable({ onlySelf: true });
            (<FormControl>this.form.controls['gift.receiver']).disable({ onlySelf: true });
        }
        this.form.updateValueAndValidity({onlySelf: true});
    }
}
